import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import _ from 'lodash';
import { ButtonModule } from 'primeng/button';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { SelectModule } from 'primeng/select';
import { PanelModule } from 'primeng/panel';
import { ModalComponent } from '../../shared/modal/modal.component';
import { CustomFormControl } from '../../shared/shared.model';
import { MultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'app-authorization',
  imports: [InputTextModule, CommonModule, ButtonModule, SelectModule, ReactiveFormsModule, DropdownModule, PanelModule, ModalComponent, MultiSelectModule],
  templateUrl: './authorization.component.html',
  styleUrl: './authorization.component.scss'
})

export class AuthorizationComponent implements OnInit {
  @Input() subjects: any;
  @Input() formData: any;
  @Input() states: any;
  @Output() formChanged = new EventEmitter<void>();
  formGroup!: FormGroup;
  subjectNames: any[] = [];
  showDeleteModal: boolean = false;
  itemToDelete: any;

  ngOnInit(): void {
    if (this.subjects) {
      let nameList = _.map(_.get(this.subjects, 'subjects'),item => ({ name: item.recordSubjectName, value: item.recordSubjectName }));
      if (nameList && !_.isNull(nameList[0])) {
        this.subjectNames = nameList;
      }

    }

    this.formGroup = new FormGroup({
      'authorizations': new FormArray([this.createAuthorizationFormGroup()]),
      'caseNumber': new FormControl(null)
    });

    if(this.formData) {
      this.initializeFormData();
    } 

    this.formGroup.valueChanges.subscribe(()=>{
      this.formChanged.emit();
    });
  }

  /**
   * Gets the authorizations form array.
   * @returns The FormArray of authorizations.
   */
  get authorizations(): FormArray {
    return this.formGroup.get('authorizations') as FormArray;
  }

  /**
   * Adds a new authorization to the authorizations form array.
   */
  addAuthorization(): void {
    this.authorizations.push(this.createAuthorizationFormGroup());
  }

  /**
   * Removes a authorization from the authorizations form array.
   * @param index The index of the authorization to remove.
   */
  removeAuthorization(index: number) {
    // this.authorizations.removeAt(index);
    this.showDeleteModal = true;
    this.itemToDelete = index;
  }

  createAuthorizationFormGroup(item?: any): FormGroup {
    return new FormGroup({
      'recordSubjectName': new CustomFormControl((item && item?.recordSubjectName?.length > 0) ? item?.recordSubjectName : (this.subjectNames.length == 1 ? this.subjectNames : null), 'Record Subject Name', [Validators.required]),
      'opposingCounselAttorneyName': new CustomFormControl(item ? item?.opposingCounselAttorneyName : null, 'Opposing Counsel Attorney Name', [Validators.required]),
      'opposingCounselFirmName': new CustomFormControl(item ? item?.opposingCounselFirmName : null, 'Opposing Counsel Firm Name', [Validators.required]),
      'streetAddress': new FormControl(item ? item?.streetAddress : null),
      'city': new FormControl(item ? item?.city : null),
      'state': new FormControl(item ? item?.state : null),
      'zip': new FormControl(item ? item?.zip : null),
      'phone': new FormControl(item ? item?.phone : null),
      'extn': new FormControl(item ? item?.extn : null),
      'fax': new FormControl(item ? item?.fax : null),
      'email': new CustomFormControl(item ? item?.email : null, 'Email', [Validators.email])
    });
  }

  /**
  * Highlights a control for validation.
  */
  isError(controlId: any, control?:any) {
    let formControl = this.formGroup.get(controlId);
    if(!formControl)
      formControl = control.get(controlId);
    return formControl ? (formControl.invalid && (formControl.dirty || formControl.touched)) : false;
  }

  delete() {
    if(this.itemToDelete >= 0) {
      this.authorizations.removeAt(this.itemToDelete);
      this.itemToDelete = null;
      this.showDeleteModal = false;
    }
    
  }

  initializeFormData() {
    if (this.formData?.authorizations) {
      this.authorizations.clear();
      _.forEach(this.formData.authorizations, subject => {
        this.authorizations.push(this.createAuthorizationFormGroup(subject));
      });
    }
  
    if (this.formData?.caseNumber) {
      this.formGroup.get('caseNumber')?.setValue(this.formData.caseNumber);
    }
  }
  

}
